module.exports = __webpack_public_path__ + "static/media/DeliveryPerson.8740bd13.png";